// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"479":"10c81baf19b252b2deda","1850":"af1408465393edff406a","8762":"44761a8152490fb65e7a"}[chunkId] + ".css";
};